export default class CelulaOptions {
  constructor({
    outlined = false,
    usePadding = false,
    justifyCenter = false,
    elevation = 2,
    qtdColunasPorCelula = 0,
    handleInputChange = () => {},
  } = {}) {
    this.outlined = outlined
    this.usePadding = usePadding
    this.justifyCenter = justifyCenter
    this.elevation = elevation
    this.qtdColunasPorCelula = qtdColunasPorCelula
    this.handleInputChange = handleInputChange
  }
}
